import React from "react";
import { ClubLogo } from "../primitives";
import Confetti from "../Confetti";
import JoinButton from "./JoinButton";

/** Explore Clubs card (mockup `.clubcard`). Tapping the card opens the club; the join button does not. */
export default function ClubCard({ club, state, busy, burst = 0, onOpen, onJoin }) {
  const open = () => onOpen(club);
  return (
    <div
      className="card clubcard"
      role="button"
      tabIndex={0}
      data-testid={`home.row.${club.id}`}
      onClick={open}
      onKeyDown={(e) => { if (e.target === e.currentTarget && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); open(); } }}
    >
      {burst > 0 && <Confetti fire={burst} />}
      <ClubLogo club={club} size={54} />
      <div className="grow" style={{ minWidth: 0 }}>
        <h3>{club.name}</h3>
        <div className="meta">{[club.category, `${club.member_count || 0} members`].filter(Boolean).join(" · ")}</div>
        {club.description ? <p>{club.description}</p> : null}
      </div>
      <div style={{ alignSelf: "center" }} onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
        <JoinButton state={state} busy={busy} onPress={() => onJoin(club, state)} testId={`home.row.${club.id}.join`} />
      </div>
    </div>
  );
}
